import styled from "@emotion/styled";

export const ConversationWrap = styled.div`
    width: 100%;
    flex: 1;
    min-height: 0;

    display: flex;
    flex-direction: column;
    align-items: center;

    overflow: hidden;
`;

export const MessageRow = styled.div`
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-width: 1023px) {
        max-width: 100%;
    }
`;

export const ListenAndAvatarRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 36px;
    width: 100%;
    min-width: 0;
`;

export const AvatarWrap = styled.div`
    width: 28px;
    height: 28px;
    border-radius: 9999px;
    border: 1px solid #2457e3;
    overflow: hidden;
    flex-shrink: 0;
    background: #1e1f22;
`;

export const AvatarImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`;

export const MessageContent = styled.div`
    width: 100%;
    padding-left: 36px;
`;

export const TextContent = styled.div`
    width: 100%;
    overflow: hidden;
`;

export const TextBlock = styled.div`
  font-family: "Custora", serif;
    font-weight: 400;
    font-size: 17px;
    line-height: 150%;
    color: #e9ecf5;
    white-space: pre-line;
`;
